import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useCurrentUser } from '@/features/auth/require-auth.tsx'
import { useLogout } from '@/features/auth/use-session.ts'
import { RemindersWindow } from '@/features/salons/components/reminders-window.tsx'
import { resetSeenReminders } from '@/features/salons/seen-reminders.ts'
import { useAppHeight } from '@/shared/hooks/use-app-height.ts'
import { cn } from '@/shared/lib/cn.ts'
import { MobileTabBar } from './mobile-tab-bar.tsx'
import { Sidebar } from './sidebar.tsx'

// Tables and the two-pane chats use the whole screen; reading pages keep a comfortable column.
const FULL_WIDTH_PATHS = ['/salons', '/referrals', '/promo-codes', '/staff', '/support']

export function AdminLayout() {
  const user = useCurrentUser()
  const { pathname } = useLocation()
  const fullWidth = FULL_WIDTH_PATHS.some((path) => pathname.startsWith(path))
  const navigate = useNavigate()
  const { mutate: logout, isPending } = useLogout()
  useAppHeight()

  const handleLogout = () => {
    if (isPending) return
    logout(undefined, {
      onSettled: () => {
        resetSeenReminders()
        navigate('/login', { replace: true })
      },
    })
  }

  return (
    <div className="flex min-h-screen flex-col bg-canvas text-ink md:flex-row">
      <Sidebar user={user} onLogout={handleLogout} />
      <main
        className={cn(
          // On phones the content clears the status bar on top and the tab bar at the bottom.
          'min-w-0 flex-1 px-4 pt-[calc(20px+env(safe-area-inset-top))] pb-[calc(84px+env(safe-area-inset-bottom))]',
          'md:px-9 md:pt-8.5 md:pb-15',
          !fullWidth && 'max-w-[1060px]',
        )}
      >
        <Outlet />
      </main>
      <MobileTabBar user={user} onLogout={handleLogout} />
      <RemindersWindow enabled={user.sections.includes('salons')} />
    </div>
  )
}
